export enum Backgrounds {
    ACCENT_100 = 'bg-accent-100',
    SHADE_100 = 'bg-shade-100',
    SHADE_0 = 'bg-shade-0',
    WHITE = 'bg-white',
}
